import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

document.documentElement.lang = 'tr';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />
);

// Register service worker for PWA functionality
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('✅ ONXFLOW PWA is ready for offline use!');
  },
  onUpdate: (registration) => {
    console.log('🔄 New version available! Refresh to update.');
    // Optionally show a toast notification to user
  }
});

// Enable install prompt
serviceWorkerRegistration.showInstallPromotion();
